<template>
    <div class="widgets customers_stats_widgets" :class="addClass">
        <div v-for="item in statistic" class="stat-widget" :key="item.id">
            <img :src="item.imgPath" class="widget-icon">
            <span class="stat-title">{{item.title}}</span>
            <div class="stat-info">
                <div class="small-text">{{item.value}}</div>
                <div class="delta" :class="item.deltaClass">{{item.delta}}</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "CustomersStats",
    props: ['addClass', 'stats'],
    data() {
        return {
            statistic: [
                {
                    id: 3,
                    imgPath: require('@/assets/img/visitors.svg'),
                    title: "Customers",
                    value: "3,381",
                    delta: "0.54%",
                    deltaClass: "delta-up"
                },
                {
                    id: 2,
                    imgPath: require('@/assets/img/purchases.svg'),
                    title: "Purchases",
                    value: "802",
                    delta: "0.54%",
                    deltaClass: "delta-up"
                },
                {
                    id: 1,
                    imgPath: require('@/assets/img/purchased_atempts_icon.svg'),
                    title: "Purchase Attempts",
                    value: "550",
                    delta: "0.54%",
                    deltaClass: "delta-down"
                },
                {
                    id: 4,
                    imgPath: require('@/assets/img/conversion.svg'),
                    title: "AOV Growth",
                    value: "187",
                    delta: "0.54%",
                    deltaClass: "delta-up"
                },
            ]
        }
    },
    computed: {
    },
    methods: {
        getDelta(last, beforeLast) {
            var delta,
                deltaClass;
            
            if(last > beforeLast) {
                deltaClass = 'delta-up';
                delta = last / (last - beforeLast)
            } else if (last < beforeLast) {
                deltaClass = 'delta-down';
                delta = beforeLast / (beforeLast - last)
            } else {
                delta = 0;
                deltaClass = 'delta-zero';
            }
            return { delta: delta.toFixed(2), deltaClass }
        },
        init() {
            console.log(this.stats.customers);
            this.statistic.forEach(item => {
                switch (item.title) {
                    case 'Customers':
                        item.value = this.stats.customers;
                        var deltaObj = this.getDelta(this.stats['last-week-customers'], this.stats['week-before-customers'])
                        item.deltaClass = deltaObj.deltaClass
                        item.delta = deltaObj.delta;
                        break;
                    case 'Purchases':
                        item.value = this.stats.buyers
                        var deltaObj = this.getDelta(this.stats['last-week-buyers'], this.stats['week-before-buyers'])
                        item.deltaClass = deltaObj.deltaClass
                        item.delta = deltaObj.delta;
                        break;
                    case 'Purchase Attempts':
                        item.value = this.stats['purchase-attempts']
                        var deltaObj = this.getDelta(this.stats['last-week-attempts'], this.stats['week-before-attempts'])
                        item.deltaClass = deltaObj.deltaClass
                        item.delta = deltaObj.delta;
                        break;
                    case 'AOV Growth':
                        item.value = Math.round(this.stats.avg);
                        var deltaObj = this.getDelta(Math.round(this.stats['last-week-avg']), Math.round(this.stats['week-before-avg']))
                        item.deltaClass = deltaObj.deltaClass
                        item.delta = deltaObj.delta;
                        break;            
                }
            });
        },
    },
    mounted() {
        this.init()
    }
}
</script>